
    <div (click)="reject()" class="icon close-popup"><i class="fal fa-times"></i></div>
    <div class="label blue-label">Bonus activated</div>
    <div class="_10px-spacer"></div>
    <h3>You got 27 free spins:</h3>
    <img src="/assets/images/bonus-img-1.png" height="200" />
    <p>You got 20 Roulette Free Spins & 7 Slot Free Spins</p>
    <a [routerLink]="['/account/bonus', { outlets: { modal: null } }]" (click)="close()">
      <app-form-button class="primary full-width"> Activate your bonus </app-form-button>
    </a>
    <div class="log-in-or-text">Or</div>
    <a [routerLink]="['/', { outlets: { modal: 'deposit' } }]" (click)="close()" class="button-transparent full-width">
      Deposit & get up to 7 BTC
    </a>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/phone-bonuses-modal.component.ts.PhoneBonusesModalComponent.html